import React from "react";
import {IonContent, IonHeader, IonPage} from "@ionic/react";
import AppToolbar from "../../components/utils/AppToolbar";
import StepsAccordingToSpecificationsService from "../../services/steps/StepsAccordingToSpecificationsService";
import NavigationBetweenSteps from "../../components/steps/NavigationBetweenStep";
import {EOperationType} from "../../models/utils/EOperationType";
import {AOperation} from "../../models/operations/AOperation";
import OperationService from "../../services/OperationService";
import ValidationStep from "../../components/steps/validation/ValidationStep";
import Error from "../../components/utils/alert/error/Error";
import {Alert, Snackbar} from "@mui/material";
import OperationLocalService from "../../services/storage/localStorage/OperationLocalService";

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 09/05/2022
 * @last_update 09/05/2022
 **/
class OperationPage extends React.Component<{
    pageTitle: string,
    currentOperationData: AOperation | EOperationType,
}, {
    progressStep: number,
    operation: AOperation,
    isOver: boolean,
    isErrorVisible: boolean,
    errorContent: string,
    isToastOpen: boolean
}> {

    constructor(props: any) {
        super(props);
        const operation = OperationService.convertOperationTypeToOperation(this.props.currentOperationData);
        this.state = {progressStep: 0, operation: operation, isOver: false, isErrorVisible: false, isToastOpen: false, errorContent: ""};
    }

    render() {

        const movingBackOrForth = (direction: boolean) => {
            if(direction) {
                if(this.state.progressStep > 0) {
                    this.setState({progressStep: this.state.progressStep - 1, isOver: false});
                }
            } else {
                if(this.state.progressStep === (steps.length - 1)) {
                    this.setState({isOver: true});
                }
                this.setState({progressStep: this.state.progressStep + 1});
            }
        }

        const setOperation = (operation: AOperation) => {
            this.setState({operation: operation});
            movingBackOrForth(false);
        }

        const steps = StepsAccordingToSpecificationsService.getOperationSteps(this.state.operation, setOperation);

        const onValidate = () => {
            if(this.state.operation.isCorrect()) {
                const operationStored = OperationLocalService.getOperationById(this.state.operation.id);
                if(operationStored) {
                    // Update
                    OperationLocalService.updateOperation(this.state.operation);
                } else {
                    // Add
                    OperationLocalService.createOperation(this.state.operation);
                }
                this.setState({
                    isErrorVisible: false,
                    isToastOpen: true
                });
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            } else {
                this.setState({
                    isErrorVisible: true,
                    errorContent: "Les données saisies sont invalides. Corrigez le formulaire et réessayez."
                });
            }
        }

        const validationComponent = (
            <ValidationStep
                operation={this.state.operation}
                onBack={() => {movingBackOrForth(true)}}
                onValidate={onValidate}
            />
        );

        const getFormComponent = () => {
            return (
                <div className="installProcessContainer">
                    <NavigationBetweenSteps
                        componentFromStep={steps}
                        stepInProgress={steps[this.state.progressStep]}
                        movingBackOrForth={movingBackOrForth}
                    />
                    {  // The component is displayed according to the current stage
                        steps[this.state.progressStep].component
                    }
                </div>
            );
        };

        const getRightComponent = () => {
            let component: JSX.Element;
            if(this.state.isOver) {
                component = validationComponent;
            } else {
                component = getFormComponent();
            }
            return component;
        }

        const changeToastVisibility = () => {
            this.setState({isToastOpen: !this.state.isToastOpen});
        }

        return (

            <IonPage>
                <IonHeader>
                    <AppToolbar appTitle={this.props.pageTitle}/>
                </IonHeader>
                <IonContent fullscreen>
                    {
                        this.state.isErrorVisible ? <Error>{this.state.errorContent}</Error> : ""
                    }
                    {  // The component is displayed according to the current stage
                        getRightComponent()
                    }
                    <Snackbar open={this.state.isToastOpen} autoHideDuration={6000} onClose={changeToastVisibility}>
                        <Alert onClose={changeToastVisibility} severity="success" sx={{ width: '100%' }}>
                            Opération sauvegardée avec succès !
                        </Alert>
                    </Snackbar>
                </IonContent>
            </IonPage>

        );

    };

}

export default OperationPage;
